import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dException from "../Effect.Exception/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
const $RequestState = (tag, _1) => ({tag, _1});
const NotRequested = /* #__PURE__ */ $RequestState("NotRequested");
const Loading = /* #__PURE__ */ $RequestState("Loading");
const Loaded = value0 => $RequestState("Loaded", value0);
const startAff = dictMonadFRP => action => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(dictMonadFRP.MonadEffect0().liftEffect((() => {
  const $0 = Effect$dAff._makeFiber(Effect$dAff.ffiUtil, action);
  return () => {
    const fiber = $0();
    fiber.run();
    return fiber;
  };
})()))(fiber => dictMonadFRP.MonadCleanup1().onCleanup((() => {
  const $0 = Effect$dAff._makeFiber(Effect$dAff.ffiUtil, Effect$dAff.killFiber(Effect$dException.error("Cancelled"))(fiber));
  return () => {
    const fiber$1 = $0();
    fiber$1.run();
  };
})()));
const performEvent = dictMonadFRP => event => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dFRP$dBase.newEvent(dictMonadFRP.MonadEffect0()))(output => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dFRP$dBase.subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(action => {
  const $0 = Effect$dAff._makeFiber(Effect$dAff.ffiUtil, Effect$dAff._bind(action)(x => Effect$dAff._liftEffect(output.fire(x))));
  return () => {
    const fiber = $0();
    fiber.run();
  };
})(event))(() => dictMonadFRP.MonadCleanup1().Monad0().Applicative0().pure(output.event)));
const genericRequestState = {
  to: x => {
    if (x.tag === "Inl") { return NotRequested; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Loading; }
      if (x._1.tag === "Inr") { return $RequestState("Loaded", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "NotRequested") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Loading") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Loaded") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const showRequestState = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "NotRequested"});
      const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Loading"});
      const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [dictShow.show(v)]})({reflectSymbol: () => "Loaded"});
      return x => {
        const $3 = genericRequestState.from(x);
        if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
        if ($3.tag === "Inr") {
          if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
          if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      };
    })()
  }
);
const functorRequestState = {
  map: f => m => {
    if (m.tag === "NotRequested") { return NotRequested; }
    if (m.tag === "Loading") { return Loading; }
    if (m.tag === "Loaded") { return $RequestState("Loaded", f(m._1)); }
    $runtime.fail();
  }
};
const fromLoaded = v => {
  if (v.tag === "Loaded") { return Data$dMaybe.$Maybe("Just", v._1); }
  return Data$dMaybe.Nothing;
};
const eqRequestState = dictEq => (
  {
    eq: x => y => {
      if (x.tag === "NotRequested") { return y.tag === "NotRequested"; }
      if (x.tag === "Loading") { return y.tag === "Loading"; }
      if (x.tag === "Loaded") {
        if (y.tag === "Loaded") { return dictEq.eq(x._1)(y._1); }
        return false;
      }
      return false;
    }
  }
);
const asyncRequestMaybe = dictMonadEffect => dictMonadFRP => dquery => dictMonadEffect.Monad0().Bind1().bind(Specular$dFRP$dBase.newEvent(dictMonadEffect))(loadStateChanged => dictMonadEffect.Monad0().Bind1().bind(dictMonadEffect.liftEffect(() => (
  {value: () => {}}
)))(cancelCurrentRef => dictMonadEffect.Monad0().Bind1().bind(dictMonadEffect.liftEffect(Specular$dFRP$dBase.readNode(dquery)))(initialValue => dictMonadEffect.Monad0().Bind1().bind(Specular$dFRP$dBase.foldDyn(dictMonadFRP)(x => v => x)((() => {
  if (initialValue.tag === "Just") { return Loading; }
  if (initialValue.tag === "Nothing") { return NotRequested; }
  $runtime.fail();
})())(Specular$dFRP$dBase.leftmost([
  Specular$dFRP$dBase.functorEvent.map(v => {
    if (v.tag === "Just") { return Loading; }
    if (v.tag === "Nothing") { return NotRequested; }
    $runtime.fail();
  })(dquery),
  loadStateChanged.event
])))(dyn => dictMonadEffect.Monad0().Bind1().bind(Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP)(m_query => () => {
  const cancelCurrent = cancelCurrentRef.value;
  cancelCurrent();
  if (m_query.tag === "Nothing") { return cancelCurrentRef.value = () => {}; }
  if (m_query.tag === "Just") {
    const fiber = Effect$dAff._makeFiber(
      Effect$dAff.ffiUtil,
      Effect$dAff._bind(m_query._1)(value => Effect$dAff._liftEffect(loadStateChanged.fire($RequestState("Loaded", value))))
    )();
    fiber.run();
    const $0 = Effect$dAff._makeFiber(Effect$dAff.ffiUtil, Effect$dAff.killFiber(Effect$dException.error("Cancelled"))(fiber));
    return cancelCurrentRef.value = () => {
      const fiber$1 = $0();
      fiber$1.run();
    };
  }
  $runtime.fail();
})(dquery))(() => dictMonadEffect.Monad0().Applicative0().pure(dyn))))));
const asyncRequest = dictMonadEffect => dictMonadFRP => dquery => asyncRequestMaybe(dictMonadEffect)(dictMonadFRP)(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(dquery));
export {
  $RequestState,
  Loaded,
  Loading,
  NotRequested,
  asyncRequest,
  asyncRequestMaybe,
  eqRequestState,
  fromLoaded,
  functorRequestState,
  genericRequestState,
  performEvent,
  showRequestState,
  startAff
};
